<template>
  <div class="order-time-settings">
    <div class="page-header"><h2><span class="breadcrumb-level">订单管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">订单设置</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">时效配置</span></h2></div>
    <el-card>
      <template #header>      </template>

      <el-form :model="form" label-width="140px">
        <el-form-item
          v-for="(item, idx) in form.settings"
          :key="item.type"
          :label="item.label"
          :prop="'settings.' + idx + '.minutes'"
          :rules="[{ required: true, message: '请输入分钟数', trigger: 'blur' }, { type: 'number', min: 1, max: 1440, message: '范围 1-1440', trigger: 'blur' }]"
        >
          <el-input-number v-model="item.minutes" :min="1" :max="1440" />
          <span class="unit">分钟</span>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSave" :loading="saving">保存</el-button>
          <el-button @click="fetchData">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import * as api from '../../api/orders'

const saving = ref(false)
const form = reactive({
  settings: []
})

const fetchData = async () => {
  try {
    const res = await api.getOrderTimeSettings()
    form.settings = (res.data || []).map(s => ({ type: s.type, label: s.label, minutes: s.minutes }))
  } catch (e) {
    ElMessage.error('加载失败')
  }
}

const handleSave = async () => {
  saving.value = true
  try {
    await api.updateOrderTimeSettings({ settings: form.settings })
    ElMessage.success('保存成功')
  } catch (e) {
    ElMessage.error('保存失败')
  } finally {
    saving.value = false
  }
}

onMounted(fetchData)
</script>

<style scoped>
.order-time-settings {
  max-width: 600px;
}
.unit {
  margin-left: 10px;
  color: #999;
  font-size: 14px;
}
</style>
